// extracted by mini-css-extract-plugin
export default {"container":"RichTextEditor_container__T-xNW","error":"RichTextEditor_error__FYh80"};